import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import 'vue-loading-overlay/dist/css/index.css';
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

const app = createApp(App);
app.use(router).use(store).use(Toast);
app.mount('#app');
